import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Route to translation key mapping
// This makes it easy to add new routes - just add an entry here
const ROUTE_TO_TITLE_MAP: Record<string, string> = {
    '/': 'pages.home',
    '/about': 'pages.about',
    '/tournaments': 'pages.tournaments',
    '/privacy': 'pages.privacy',
    '/imprint': 'pages.imprint',
    '/terms': 'pages.terms',
    '/event-rules': 'pages.eventRules',
}

export const usePageTitle = () => {
    const { t, i18n } = useTranslation()
    const location = useLocation()

    useEffect(() => {
        // Look up the translation key for the current route
        const translationKey = ROUTE_TO_TITLE_MAP[location.pathname]

        // If route is found in mapping, use it; otherwise show 404 page title
        const pageTitle = translationKey
            ? t(translationKey)
            : t('pages.notFound')

        document.title = pageTitle

        // Update HTML lang attribute
        const htmlLang = i18n.language === 'de-DE' ? 'de' : 'en'
        document.documentElement.lang = htmlLang
    }, [location.pathname, t, i18n.language])
}
